import { render, staticRenderFns } from "./drawAllParts.vue?vue&type=template&id=2b54e5e7&scoped=true&"
import script from "./drawAllParts.vue?vue&type=script&lang=js&"
export * from "./drawAllParts.vue?vue&type=script&lang=js&"
import style0 from "./drawAllParts.vue?vue&type=style&index=0&id=2b54e5e7&prod&scoped=true&lang=less&"
import style1 from "./drawAllParts.vue?vue&type=style&index=1&id=2b54e5e7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54e5e7",
  null
  
)

export default component.exports